import {
  CircularProgress,
  InputAdornment,
  MenuItem,
  TextField
} from '@material-ui/core'
import {RouteComponentProps} from '@reach/router'
import {Box, BoxComponentProps} from 'reoil'
import Navigation from '../components/Navigation'
import useFetchResume from '../hooks/api/useFechResume'
import {responseBoxProp} from '../utils/propsHelpers'
/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx, css} from '@emotion/core'
import DateFnsUtils from '@date-io/dayjs'
import localZh from 'dayjs/locale/zh'
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import {useFormik} from 'formik'
import useFetchCities from '../hooks/api/useFetchCities'
import EduExperience from '../components/UserResumeEditPage/EduExperience'
import StudentUnionList from '../components/UserResumeEditPage/StudentUnionList'
import PracticeExperienceList from '../components/UserResumeEditPage/PracticeExperienceList'
import AwardInfoList from '../components/UserResumeEditPage/AwardInfoList'
import BtnBottom from '../components/BtnBottom'
import UploadAvatar from '../components/UserResumeEditPage/UploadAvatar'
import avatar from '../assets/images/avatar.png'
import UploadFile from '../components/UserResumeEditPage/UploadFile'
import fetcher from '../utils/fetcher'
import getBirthFromId from '../utils/getBirthFromId'
import {ResponseData} from '../hooks/api/types'
import {toast} from 'react-toastify'
import goto from '../utils/goto'
import {useSetLoginState} from '../store/loginState'
import {useUploadingState} from '../store/uploadingState'

// 性别列表
const genders = [
  {value: '1', label: '男'},
  {value: '0', label: '女'}
]

// 学历列表
const educationLevels = ['其他', '大学本科', '硕士研究生', '博士研究生']

// 政治面貌
const politics = ['其他', '群众', '共青团员', '中共党员']

// 民族
const userNations = [
  '汉族',
  '满族',
  '蒙古族',
  '回族',
  '藏族',
  '维吾尔族',
  '苗族',
  '彝族',
  '壮族',
  '布依族',
  '侗族',
  '瑶族',
  '白族',
  '土家族',
  '哈尼族',
  '哈萨克族',
  '傣族',
  '黎族',
  '傈僳族',
  '佤族',
  '畲族',
  '高山族',
  '拉祜族',
  '水族',
  '东乡族',
  '纳西族',
  '景颇族',
  '柯尔克孜族',
  '土族',
  '达斡尔族',
  '仫佬族',
  '羌族',
  '布朗族',
  '撒拉族',
  '毛南族',
  '仡佬族',
  '锡伯族',
  '阿昌族',
  '普米族',
  '朝鲜族',
  '塔吉克族',
  '怒族',
  '乌孜别克族',
  '俄罗斯族',
  '鄂温克族',
  '德昂族',
  '保安族',
  '裕固族',
  '京族',
  '塔塔尔族',
  '独龙族',
  '鄂伦春族',
  '赫哲族',
  '门巴族',
  '珞巴族',
  '基诺族',
  '其他'
]

// 婚姻状况
const marryStatusArr = [
  {status: '0', value: '未婚'},
  {status: '1', value: '已婚'}
]

// 服从调剂
const obeys = [
  {status: '1', value: '服从调剂'},
  {status: '0', value: '不服从调剂'}
]

// 缓存表单
// const formToken = localStorage.getItem('form') && JSON.parse(localStorage.getItem('form')||'{}')

const UserResumeEditPage: React.FC<RouteComponentProps> = () => {
  // 获取数据
  const {data} = useFetchResume()
  const info = data?.data

  // 获取城市数据
  const {data: CityData} = useFetchCities()
  const interviewCities = CityData?.data.interview.map(item => item.name)

  // 更新全局头像
  const setLoginState = useSetLoginState()
  const updateAvatar = (avatar: string) => {
    setLoginState(prev => ({...prev, avatar}))
  }

  // 表单状态
  const formik = useFormik({
    initialValues: {
      headImg: info ? (info.headImg as string) : '',
      userName: info?.userName || '',
      gender: info?.gender || '',
      idCard: info?.idCard || '',
      birthDate: info?.birthDate || null,
      education: info?.education || '',
      politic: info?.politic || '',
      userNation: info?.userNation || '',
      nativePlace: info?.nativePlace || '',
      registeredResidence: info?.registeredResidence || '',
      height: info?.height || '',
      weight: info?.weight || '',
      marryStatus: info?.marryStatus || '',
      foreignLanguageLevel: info?.foreignLanguageLevel || '',
      computerLevel: info?.computerLevel || '',
      email: info?.email || '',
      specialty: info?.specialty || '',
      resumeFile: info?.resumeFile || '',
      answer1: info?.answer1 || '',
      answer2: info?.answer2 || '',
      answer3: info?.answer3 || '',
      canAdjustment: info?.canAdjustment || '',
      intendedJobs: [info?.intendedJobs[0] || '', info?.intendedJobs[1] || ''],
      interviewCityIDs: info?.interviewCityIDs || '',
      // interviewCityIDs: info?.interviewCityIDs ? info?.interviewCityIDs.map(item=>item.id) : [],
      educationDetailList: info?.educationDetailList || [],
      awardInfoList: info?.awardInfoList || [],
      practiceExperienceList: info?.practiceExperienceList || [],
      award: info?.award || '',
      selfEval: info?.selfEval || '',
      studentUnionList: info?.studentUnionList || []
    },
    enableReinitialize: true,
    validate: values => {
      const errors = {}
      // console.log( JSON.stringify(values, null, 2) )
      return errors
    },
    onSubmit: values => {
      submitForm() // 提交表单
    }
  })

  // 表单数据
  const form = formik.values

  // 点击保存按钮 触发提交表单
  const handleClickSave = () => {
    formik.submitForm()
  }

  // 正在上传中
  const [isUploading] = useUploadingState()

  const submitForm = async () => {
    const res: ResponseData<unknown> = await fetcher.post(
      '/content.php?a=saveResumeAndDelivery',
      form
    )

    if (res.success) {
      toast('简历修改成功', {type: 'success'})
      updateAvatar(form.headImg)
      goto(-1)
    }
  }

  // 更新生日
  const updateBirthDate = (idCard: string | null) => {
    const newBirthDate = getBirthFromId(idCard)
    console.log(idCard)
    if (newBirthDate) formik.setFieldValue('birthDate', newBirthDate)
  }

  if (!info) return <div></div>

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localZh}>
      <Box className='UserResumeEditPage' stretch pb={6}>
        <Navigation title='修改简历' hideAvatar height={59} />

        <Box className='form' bg='white' p={3} pb={4}>
          <Box
            {...responseBoxProp}
            stretch
            css={css`
              .field {
                margin-bottom: 12px;
              }
            `}>
            <SubTitle>
              基本信息
              <i style={{color: 'orangered'}}>*</i>
            </SubTitle>

            <UploadAvatar
              initialSrc={form.headImg || avatar}
              onChange={response =>
                formik.setFieldValue('headImg', response.publishUrl)
              }
            />

            <TextField
              className='field'
              label='真实姓名'
              variant='filled'
              name='userName'
              value={form.userName}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='性别'
              variant='filled'
              name='gender'
              select
              value={form.gender}
              onChange={formik.handleChange}
              required>
              {genders.map(item => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              className='field'
              label='身份证号码'
              variant='filled'
              name='idCard'
              value={form.idCard}
              onChange={(ev, ...args) => {
                formik.handleChange(ev, ...args)
                updateBirthDate(ev.target.value)
              }}
              required
            />
            <DatePicker
              label='出生年月'
              style={{marginBottom: 12}}
              openTo='year'
              cancelLabel='取消'
              okLabel='确定'
              format='YYYY-MM-DD'
              value={form.birthDate}
              onChange={date => {
                formik.setFieldValue('birthDate', date?.format('YYYY-MM-DD'))
              }}
              required
            />
            <TextField
              className='field'
              label='最高学历'
              variant='filled'
              select
              name='education'
              value={form.education}
              onChange={formik.handleChange}
              required>
              {educationLevels.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              className='field'
              label='政治面貌'
              variant='filled'
              select
              name='politic'
              value={form.politic}
              onChange={formik.handleChange}
              required>
              {politics.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              className='field'
              label='民族'
              variant='filled'
              select
              name='userNation'
              value={form.userNation}
              onChange={formik.handleChange}
              required>
              {userNations.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              className='field'
              label='籍贯 (省+市)'
              variant='filled'
              name='nativePlace'
              value={form.nativePlace}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='户口所在地'
              variant='filled'
              name='registeredResidence'
              value={form.registeredResidence}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='身高'
              type='number'
              variant='filled'
              name='height'
              value={form.height}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>CM</InputAdornment>
                )
              }}
              required
            />
            <TextField
              className='field'
              label='体重'
              type='weight'
              variant='filled'
              name='weight'
              value={form.weight}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>KG</InputAdornment>
                )
              }}
              required
            />
            <TextField
              className='field'
              label='婚姻状况'
              variant='filled'
              select
              name='marryStatus'
              value={form.marryStatus}
              onChange={formik.handleChange} required>
              {marryStatusArr.map(item => (
                <MenuItem key={item.status} value={item.status}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              className='field'
              label='外语水平'
              multiline
              variant='filled'
              name='foreignLanguageLevel'
              value={form.foreignLanguageLevel}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='计算机水平'
              multiline
              variant='filled'
              name='computerLevel'
              value={form.computerLevel}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='邮箱地址'
              variant='filled'
              name='email'
              value={form.email}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='特长与爱好'
              multiline
              variant='filled'
              name='specialty'
              value={form.specialty}
              onChange={formik.handleChange}
              required
            />
            <TextField
              className='field'
              label='是否服从调剂'
              variant='filled'
              select
              name='canAdjustment'
              value={form.canAdjustment}
              onChange={formik.handleChange} required>
              {obeys.map(item => (
                <MenuItem key={item.status} value={item.status}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
            {/* <Box row>
              <TextField
                className='field'
                label='意向岗位1'
                variant='filled'
                name='intendedJobs[0]'
                value={form.intendedJobs[0]}
                style={{marginRight: 12}}
                onChange={formik.handleChange}
              />
              <TextField
                className='field'
                label='意向岗位2'
                variant='filled'
                name='intendedJobs[1]'
                value={form.intendedJobs[1]}
                onChange={formik.handleChange}
              />
            </Box> */}
            <TextField
              className='field'
              label='选择意向面试城市'
              variant='filled'
              name='interviewCityIDs'
              select
              value={form.interviewCityIDs}
              onChange={formik.handleChange} required>
              {interviewCities ? (
                interviewCities.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))
              ) : (
                <div></div>
              )}
            </TextField>

            <TextField
              className='field'
              label='获奖情况'
              multiline
              variant='filled'
              name='award'
              value={form.award}
              onChange={formik.handleChange}
              required
            />

            <TextField
              className='field'
              label='自我评价'
              multiline
              variant='filled'
              name='selfEval'
              value={form.selfEval}
              onChange={formik.handleChange}
              required
            />

            <EduExperience
              educationDetailList={info.educationDetailList}
              onBlur={values =>
                formik.setFieldValue('educationDetailList', values)
              }
            />
            <StudentUnionList
              studentUnionList={info.studentUnionList}
              onBlur={values =>
                formik.setFieldValue('studentUnionList', values)
              }
            />
            <PracticeExperienceList
              practiceExperienceList={info.practiceExperienceList}
              onBlur={values =>
                formik.setFieldValue('practiceExperienceList', values)
              }
            />
            <AwardInfoList
              awardInfoList={info.awardInfoList}
              onBlur={values => formik.setFieldValue('awardInfoList', values)}
            />

            <UploadFile
              label='简历文件'
              placeholder='暂无简历，请上传'
              initialFilename={form.resumeFile as string}
              onChange={response =>
                formik.setFieldValue('resumeFile', response.publishUrl)
              }
            />

            <SubTitle>
              问答
              <i style={{color: 'orangered'}}>*</i>
            </SubTitle>
            <TextField
              multiline
              className='field'
              label='1. 您对未来有什么规划和想法？'
              variant='filled'
              name='answer2'
              value={form.answer2}
              onChange={formik.handleChange}
              required
            />
            <TextField
              multiline
              className='field'
              label='2. 校园宣讲会上您最想提问的问题是什么？'
              variant='filled'
              name='answer3'
              value={form.answer3}
              onChange={formik.handleChange}
              required
            />
          </Box>
        </Box>

        <BtnBottom onClick={handleClickSave} unFixed disabled={!!isUploading}>
          {isUploading ? (
            <CircularProgress size={20} color='inherit'></CircularProgress>
          ) : (
            '修改简历'
          )}
        </BtnBottom>
      </Box>
    </MuiPickersUtilsProvider>
  )
}

interface SubTitleProps {
  xuantian?: boolean
}

export const SubTitle: React.FC<BoxComponentProps & SubTitleProps> = ({
  xuantian,
  ...props
}) => {
  return (
    <Box className='SubTitle' my={3} color='primary' row center left>
      <h3>{props.children}</h3>
      {xuantian && (
        <span style={{marginLeft: 8, color: 'gray', fontSize: 14}}>
          选填 (完整填写可加分呦~)
        </span>
      )}
    </Box>
  )
}

export default UserResumeEditPage
